import { render, staticRenderFns } from "./ShellLoading.vue?vue&type=template&id=3d13663f&scoped=true"
import script from "./ShellLoading.vue?vue&type=script&lang=js"
export * from "./ShellLoading.vue?vue&type=script&lang=js"
import style0 from "./ShellLoading.vue?vue&type=style&index=0&id=3d13663f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d13663f",
  null
  
)

export default component.exports